import React, { useState, useEffect } from "react";
import axios from "axios";
import UploadComponent from "./components/UploadComponent";
import Login from "./components/Login";
import PlanComparison from "./components/PlanComparison";
import PlanOrganizer from "./components/PlanOrganizer";
import EditEnrollment from "./components/EditEnrollement";
import EditConsultantCompensation from "./components/EditConsultantCompensation";
import EditNationalBenchmark from "./components/EditNationalBenchmark";

//const API_URL = process.env.REACT_APP_API_URL || "http://62.146.227.105:8777";
const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const [loadingUpload, setLoadingUpload] = useState(false);
  const [loadingCompare, setLoadingCompare] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState("");
  const [version, setVersion] = useState("");
  const [processId, setProcessId] = useState(null);
  const [reloadingIds, setReloadingIds] = useState([]);
  const [logs, setLogs] = useState([]);

  const [consultantCompensation, setConsultantCompensation] = useState({
    model: "per_employee", // "per_employee" or "percentage"
    values: {} // { carrierName: value }
  });

  // { year, single, family } for the selected National Benchmark Average year,
  // or null when no year is selected. Managed by EditNationalBenchmark.
  const [benchmark, setBenchmark] = useState(null);
  // const [consultantCompensation, setConsultantCompensation] = useState({
  //   model: "per_employee",
  //   values: {
  //     "CareFirst": 20,
  //     "UHC": 30,
  //     "Cigna": 40
  //   }
  // });

  const [originalPlansData, setOriginalPlansData] = useState([]);
  // const [originalPlansData, setOriginalPlansData] = useState([
  //   {
  //     "id": "1",
  //     "fileId": "1757536799904",
  //     "fileName": "1ZUH Sanametrix, Inc. - Dec 2024 Renewal released.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "CareFirst",
  //     "type": "current",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "1-1",
  //         "tier": null,
  //         "planName": "BlueChoice Advantage Option MV3",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": null,
  //         "rates": {
  //           "individual": 817.16,
  //           "individualAndSpouse": 1879.48,
  //           "individualAndChildren": 1511.75,
  //           "family": 2484.16
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 4,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$25",
  //             "officeVisitsSpecialty": "$50",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$250",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000",
  //             "coinsurance": "20%",
  //             "outOfPocket": "$12,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "$500",
  //             "outOfPocket": "Integrated"
  //           }
  //         }
  //       },
  //       {
  //         "id": "1-2",
  //         "tier": null,
  //         "planName": "BlueChoice HMO Open Access Integrated CDH Option MV3 HSA BlueFund",
  //         "fundingType": "Fully Insured",
  //         "planType": "HMO",
  //         "hrahsa": "HSA",
  //         "notes": null,
  //         "rates": {
  //           "individual": 636.86,
  //           "individualAndSpouse": 1464.78,
  //           "individualAndChildren": 1178.19,
  //           "family": 1936.05
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$0",
  //             "officeVisitsSpecialty": "$5",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$0",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "n/a",
  //             "coinsurance": "n/a",
  //             "outOfPocket": "n/a"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "Integrated",
  //             "outOfPocket": "Integrated"
  //           }
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     "id": "2",
  //     "fileId": "1757536799904",
  //     "fileName": "1ZUH Sanametrix, Inc. - Dec 2024 Renewal released.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "CareFirst",
  //     "type": "renewal",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "2-1",
  //         "tier": null,
  //         "planName": "BlueChoice Advantage Option MV3",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Rates include Premium and Producer Service Fee (PSF). Whole health savings applies as a percentage discount to final medical premium.",
  //         "rates": {
  //           "individual": 877.77,
  //           "individualAndSpouse": 2018.93,
  //           "individualAndChildren": 1623.91,
  //           "family": 2668.44
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 4,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$25",
  //             "officeVisitsSpecialty": "$50",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$250",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000",
  //             "coinsurance": "20%",
  //             "outOfPocket": "$12,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "$500",
  //             "outOfPocket": "Integrated"
  //           }
  //         }
  //       },
  //       {
  //         "id": "2-2",
  //         "tier": null,
  //         "planName": "BlueChoice HMO Open Access Integrated CDH Option MV3 HSA BlueFund",
  //         "fundingType": "Fully Insured",
  //         "planType": "HMO",
  //         "hrahsa": "HSA",
  //         "notes": "Rates include Premium and Producer Service Fee (PSF). Whole health savings applies as a percentage discount to final medical premium.",
  //         "rates": {
  //           "individual": 687.49,
  //           "individualAndSpouse": 1581.24,
  //           "individualAndChildren": 1271.86,
  //           "family": 2089.96
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$0",
  //             "officeVisitsSpecialty": "$5",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$0",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "n/a",
  //             "coinsurance": "n/a",
  //             "outOfPocket": "n/a"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "Integrated",
  //             "outOfPocket": "Integrated"
  //           }
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     "id": "3",
  //     "fileId": "1757536799902",
  //     "fileName": "UHC Traditional Proposal.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "UHC",
  //     "type": "alternative",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "3-1",
  //         "tier": null,
  //         "planName": "DR2Q (Open Access) Rx plan: D94",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Product: INS-Choice +; Rider(s)/Other: Care Cash (CSH); Rx PDL-Network: Advantage-Natl; OP Hospital: Ded + 100%; IP Hospital: Ded + 100%; Major Diagnostics: MD Ded+100%: DDP; X-ray & Lab: X-ray $0, Lab $0: DDP",
  //         "rates": {
  //           "individual": 762.88,
  //           "individualAndSpouse": 1754.62,
  //           "individualAndChildren": 1411.33,
  //           "family": 2319.16
  //         },
  //         "enrollment": {
  //           "individual": 35,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 3,
  //           "family": 8
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Emb)",
  //             "officeVisitsPrimaryCare": "$30",
  //             "officeVisitsSpecialty": "$60",
  //             "inpatientHospital": "Ded + 100%",
  //             "emergencyRoom": "$400",
  //             "urgentCare": "$75",
  //             "lab": "$0 (DDP)",
  //             "xray": "$0",
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Emb)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000 / $12,000 (Emb)",
  //             "coinsurance": "80%",
  //             "outOfPocket": "$12,000 / $24,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$10",
  //             "retailTier2": "$35",
  //             "retailTier3": "$80",
  //             "retailTier4": "$150",
  //             "mailOrderTier1": "2.5 MO",
  //             "mailOrderTier2": "2.5 MO",
  //             "mailOrderTier3": "2.5 MO",
  //             "mailOrderTier4": "2.5 MO",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         }
  //       },
  //       {
  //         "id": "3-2",
  //         "tier": null,
  //         "planName": "DSFI (Open Access Direct HSA) Rx plan: 2V",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "HSA",
  //         "notes": "Product: INS-Choice; Rx PDL-Network: Advantage-Natl; Rider(s)/Other: N/A; OP Hospital: $250 POD; IP Hospital: Ded+$500; Major Diagnostics: MD Ded+100%: DDP; X-ray & Lab: X-ray Ded+100%, Lab Ded+100%: DDP; Pharmacy: Med Ded",
  //         "rates": {
  //           "individual": 593.86,
  //           "individualAndSpouse": 1365.88,
  //           "individualAndChildren": 1098.64,
  //           "family": 1805.33
  //         },
  //         "enrollment": {
  //           "individual": 35,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 3,
  //           "family": 8
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Ded NonEmb/OOPM Emb)",
  //             "officeVisitsPrimaryCare": "Ded+$25",
  //             "officeVisitsSpecialty": "Ded+$50",
  //             "inpatientHospital": "Ded+$500",
  //             "emergencyRoom": "Ded+$300",
  //             "urgentCare": "Ded+$75",
  //             "lab": "Ded+100% (DDP)",
  //             "xray": "Ded+100%",
  //             "coinsurance": "100%",
  //             "outOfPocket": "$5,000 / $10,000 (Ded NonEmb/OOPM Emb)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "N/A / Ded NonEmb/OOPM Emb",
  //             "coinsurance": "N/A",
  //             "outOfPocket": "N/A"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$10",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": null,
  //             "mailOrderTier1": "2.5 MO",
  //             "mailOrderTier2": "2.5 MO",
  //             "mailOrderTier3": "2.5 MO",
  //             "mailOrderTier4": null,
  //             "deductible": "Medical Deductible",
  //             "outOfPocket": null
  //           }
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     "id": "4",
  //     "fileId": "1757536799903",
  //     "fileName": "Fully Insured CP_Sanametrix Inc_9.26.2024.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "Cigna",
  //     "type": "alternative",
  //     "effectiveDate": null,
  //     "plans": [
  //       {
  //         "id": "4-1",
  //         "tier": null,
  //         "planName": "GC OAP (37042646)",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Medical services where plan deductible applies are noted with a caret (^). Formulary: Advantage; Pharmacy Network: National",
  //         "rates": {
  //           "individual": 795.63,
  //           "individualAndSpouse": 1829.97,
  //           "individualAndChildren": 1471.93,
  //           "family": 2418.73
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Non-Collective)",
  //             "officeVisitsPrimaryCare": "$25 + 100%",
  //             "officeVisitsSpecialty": "$50 + 100%",
  //             "inpatientHospital": "100% ^",
  //             "emergencyRoom": "$250 + 100% ^",
  //             "urgentCare": "$100 + 100%",
  //             "lab": "Benefit Coins",
  //             "xray": null,
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Non-Collective)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000 / $12,000",
  //             "coinsurance": "80%",
  //             "outOfPocket": "$12,000 / $24,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "50%",
  //             "mailOrderTier1": "$30",
  //             "mailOrderTier2": "$70",
  //             "mailOrderTier3": "$120",
  //             "mailOrderTier4": "50%",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         }
  //       },
  //       {
  //         "id": "4-2",
  //         "tier": null,
  //         "planName": "GC OAPIN HSA (37042652)",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "HSA",
  //         "notes": "Medical services where plan deductible applies are noted with a caret (^). Formulary: Advantage; Pharmacy Network: National",
  //         "rates": {
  //           "individual": 634.8,
  //           "individualAndSpouse": 1466.21,
  //           "individualAndChildren": 1178.42,
  //           "family": 1939.48
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Collective)",
  //             "officeVisitsPrimaryCare": "100% ^",
  //             "officeVisitsSpecialty": "$5 + 100% ^",
  //             "inpatientHospital": "100% ^",
  //             "emergencyRoom": "100% ^",
  //             "urgentCare": "100% ^",
  //             "lab": "Benefit Coins",
  //             "xray": null,
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Non-Collective)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "NA / NA",
  //             "coinsurance": "NA",
  //             "outOfPocket": "NA / NA"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "50%",
  //             "mailOrderTier1": "$30",
  //             "mailOrderTier2": "$70",
  //             "mailOrderTier3": "$120",
  //             "mailOrderTier4": "50%",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         }
  //       }
  //     ]
  //   }
  // ]);

  const [plansData, setPlansData] = useState([]);
  // const [plansData, setPlansData] = useState([
  //   {
  //     "id": "1",
  //     "fileId": "1757536799904",
  //     "fileName": "1ZUH Sanametrix, Inc. - Dec 2024 Renewal released.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "CareFirst",
  //     "type": "current",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "1-1",
  //         "tier": 1,
  //         "planName": "BlueChoice Advantage Option MV3",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": null,
  //         "rates": {
  //           "individual": 817.16,
  //           "individualAndSpouse": 1879.48,
  //           "individualAndChildren": 1511.75,
  //           "family": 2484.16
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$25",
  //             "officeVisitsSpecialty": "$50",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$250",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000",
  //             "coinsurance": "20%",
  //             "outOfPocket": "$12,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "$500",
  //             "outOfPocket": "Integrated"
  //           }
  //         },
  //         "costs": {
  //           "individual": 26149.12,
  //           "individualAndSpouse": 9397.4,
  //           "individualAndChildren": 3023.5,
  //           "family": 12420.8,
  //           "totalMonthly": 50990.81999999999,
  //           "totalAnnual": 611889.8399999999,
  //           "increase": 0
  //         }
  //       },
  //       {
  //         "id": "1-2",
  //         "tier": 2,
  //         "planName": "BlueChoice HMO Open Access Integrated CDH Option MV3 HSA BlueFund",
  //         "fundingType": "Fully Insured",
  //         "planType": "HMO",
  //         "hrahsa": "HSA",
  //         "notes": null,
  //         "rates": {
  //           "individual": 636.86,
  //           "individualAndSpouse": 1464.78,
  //           "individualAndChildren": 1178.19,
  //           "family": 1936.05
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$0",
  //             "officeVisitsSpecialty": "$5",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$0",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "n/a",
  //             "coinsurance": "n/a",
  //             "outOfPocket": "n/a"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "Integrated",
  //             "outOfPocket": "Integrated"
  //           }
  //         },
  //         "costs": {
  //           "individual": 1910.58,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1178.19,
  //           "family": 5808.15,
  //           "totalMonthly": 8896.92,
  //           "totalAnnual": 106763.04000000001,
  //           "increase": 0
  //         }
  //       }
  //     ],
  //     "totalMonthly": 59887.73999999999,
  //     "totalAnnual": 718652.8799999999
  //   },
  //   {
  //     "id": "2",
  //     "fileId": "1757536799904",
  //     "fileName": "1ZUH Sanametrix, Inc. - Dec 2024 Renewal released.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "CareFirst",
  //     "type": "renewal",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "2-1",
  //         "tier": 1,
  //         "planName": "BlueChoice Advantage Option MV3",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Rates include Premium and Producer Service Fee (PSF). Whole health savings applies as a percentage discount to final medical premium.",
  //         "rates": {
  //           "individual": 877.77,
  //           "individualAndSpouse": 2018.93,
  //           "individualAndChildren": 1623.91,
  //           "family": 2668.44
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$25",
  //             "officeVisitsSpecialty": "$50",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$250",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000",
  //             "coinsurance": "20%",
  //             "outOfPocket": "$12,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "$500",
  //             "outOfPocket": "Integrated"
  //           }
  //         },
  //         "costs": {
  //           "individual": 28088.64,
  //           "individualAndSpouse": 10094.65,
  //           "individualAndChildren": 3247.82,
  //           "family": 13342.2,
  //           "totalMonthly": 54773.31,
  //           "totalAnnual": 657279.72,
  //           "increase": 0.07417982295636771
  //         }
  //       },
  //       {
  //         "id": "2-2",
  //         "tier": 2,
  //         "planName": "BlueChoice HMO Open Access Integrated CDH Option MV3 HSA BlueFund",
  //         "fundingType": "Fully Insured",
  //         "planType": "HMO",
  //         "hrahsa": "HSA",
  //         "notes": "Rates include Premium and Producer Service Fee (PSF). Whole health savings applies as a percentage discount to final medical premium.",
  //         "rates": {
  //           "individual": 687.49,
  //           "individualAndSpouse": 1581.24,
  //           "individualAndChildren": 1271.86,
  //           "family": 2089.96
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000",
  //             "officeVisitsPrimaryCare": "$0",
  //             "officeVisitsSpecialty": "$5",
  //             "inpatientHospital": "$0",
  //             "emergencyRoom": "$0",
  //             "urgentCare": null,
  //             "lab": null,
  //             "xray": null,
  //             "coinsurance": "0%",
  //             "outOfPocket": "$6,000"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "n/a",
  //             "coinsurance": "n/a",
  //             "outOfPocket": "n/a"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "Preferred: 50% Coinsurance $100 Max; Non-Preferred: 50% Coinsurance $150 Max",
  //             "mailOrderTier1": null,
  //             "mailOrderTier2": null,
  //             "mailOrderTier3": null,
  //             "mailOrderTier4": null,
  //             "deductible": "Integrated",
  //             "outOfPocket": "Integrated"
  //           }
  //         },
  //         "costs": {
  //           "individual": 2062.4700000000003,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1271.86,
  //           "family": 6269.88,
  //           "totalMonthly": 9604.21,
  //           "totalAnnual": 115250.51999999999,
  //           "increase": 0.079498298287497
  //         }
  //       }
  //     ],
  //     "totalMonthly": 64377.52,
  //     "totalAnnual": 772530.24,
  //     "increase": 0.07496993541582975
  //   },
  //   {
  //     "id": "3",
  //     "fileId": "1757536799902",
  //     "fileName": "UHC Traditional Proposal.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "UHC",
  //     "type": "alternative",
  //     "effectiveDate": "2024-12-01",
  //     "plans": [
  //       {
  //         "id": "3-1",
  //         "tier": 1,
  //         "planName": "DR2Q (Open Access) Rx plan: D94",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Product: INS-Choice +; Rider(s)/Other: Care Cash (CSH); Rx PDL-Network: Advantage-Natl; OP Hospital: Ded + 100%; IP Hospital: Ded + 100%; Major Diagnostics: MD Ded+100%: DDP; X-ray & Lab: X-ray $0, Lab $0: DDP",
  //         "rates": {
  //           "individual": 762.88,
  //           "individualAndSpouse": 1754.62,
  //           "individualAndChildren": 1411.33,
  //           "family": 2319.16
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Emb)",
  //             "officeVisitsPrimaryCare": "$30",
  //             "officeVisitsSpecialty": "$60",
  //             "inpatientHospital": "Ded + 100%",
  //             "emergencyRoom": "$400",
  //             "urgentCare": "$75",
  //             "lab": "$0 (DDP)",
  //             "xray": "$0",
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Emb)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000 / $12,000 (Emb)",
  //             "coinsurance": "80%",
  //             "outOfPocket": "$12,000 / $24,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$10",
  //             "retailTier2": "$35",
  //             "retailTier3": "$80",
  //             "retailTier4": "$150",
  //             "mailOrderTier1": "2.5 MO",
  //             "mailOrderTier2": "2.5 MO",
  //             "mailOrderTier3": "2.5 MO",
  //             "mailOrderTier4": "2.5 MO",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         },
  //         "costs": {
  //           "individual": 24412.16,
  //           "individualAndSpouse": 8773.099999999999,
  //           "individualAndChildren": 2822.66,
  //           "family": 11595.8,
  //           "totalMonthly": 47603.72,
  //           "totalAnnual": 571244.64,
  //           "increase": -0.06642568211297617
  //         }
  //       },
  //       {
  //         "id": "3-2",
  //         "tier": 2,
  //         "planName": "DSFI (Open Access Direct HSA) Rx plan: 2V",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "HSA",
  //         "notes": "Product: INS-Choice; Rx PDL-Network: Advantage-Natl; Rider(s)/Other: N/A; OP Hospital: $250 POD; IP Hospital: Ded+$500; Major Diagnostics: MD Ded+100%: DDP; X-ray & Lab: X-ray Ded+100%, Lab Ded+100%: DDP; Pharmacy: Med Ded",
  //         "rates": {
  //           "individual": 593.86,
  //           "individualAndSpouse": 1365.88,
  //           "individualAndChildren": 1098.64,
  //           "family": 1805.33
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Ded NonEmb/OOPM Emb)",
  //             "officeVisitsPrimaryCare": "Ded+$25",
  //             "officeVisitsSpecialty": "Ded+$50",
  //             "inpatientHospital": "Ded+$500",
  //             "emergencyRoom": "Ded+$300",
  //             "urgentCare": "Ded+$75",
  //             "lab": "Ded+100% (DDP)",
  //             "xray": "Ded+100%",
  //             "coinsurance": "100%",
  //             "outOfPocket": "$5,000 / $10,000 (Ded NonEmb/OOPM Emb)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "N/A / Ded NonEmb/OOPM Emb",
  //             "coinsurance": "N/A",
  //             "outOfPocket": "N/A"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$10",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": null,
  //             "mailOrderTier1": "2.5 MO",
  //             "mailOrderTier2": "2.5 MO",
  //             "mailOrderTier3": "2.5 MO",
  //             "mailOrderTier4": null,
  //             "deductible": "Medical Deductible",
  //             "outOfPocket": null
  //           }
  //         },
  //         "costs": {
  //           "individual": 1781.58,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1098.64,
  //           "family": 5415.99,
  //           "totalMonthly": 8296.21,
  //           "totalAnnual": 99554.51999999999,
  //           "increase": -0.06751887169941972
  //         }
  //       }
  //     ],
  //     "totalMonthly": 55899.93,
  //     "totalAnnual": 670799.16,
  //     "increase": -0.06658808630948487
  //   },
  //   {
  //     "id": "4",
  //     "fileId": "1757536799903",
  //     "fileName": "Fully Insured CP_Sanametrix Inc_9.26.2024.pdf",
  //     "quotedGroup": "Sanametrix, Inc.",
  //     "carrier": "Cigna",
  //     "type": "alternative",
  //     "effectiveDate": null,
  //     "plans": [
  //       {
  //         "id": "4-1",
  //         "tier": 1,
  //         "planName": "GC OAP (37042646)",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "No",
  //         "notes": "Medical services where plan deductible applies are noted with a caret (^). Formulary: Advantage; Pharmacy Network: National",
  //         "rates": {
  //           "individual": 795.63,
  //           "individualAndSpouse": 1829.97,
  //           "individualAndChildren": 1471.93,
  //           "family": 2418.73
  //         },
  //         "enrollment": {
  //           "individual": 32,
  //           "individualAndSpouse": 5,
  //           "individualAndChildren": 2,
  //           "family": 5
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Non-Collective)",
  //             "officeVisitsPrimaryCare": "$25 + 100%",
  //             "officeVisitsSpecialty": "$50 + 100%",
  //             "inpatientHospital": "100% ^",
  //             "emergencyRoom": "$250 + 100% ^",
  //             "urgentCare": "$100 + 100%",
  //             "lab": "Benefit Coins",
  //             "xray": null,
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Non-Collective)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "$6,000 / $12,000",
  //             "coinsurance": "80%",
  //             "outOfPocket": "$12,000 / $24,000"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "50%",
  //             "mailOrderTier1": "$30",
  //             "mailOrderTier2": "$70",
  //             "mailOrderTier3": "$120",
  //             "mailOrderTier4": "50%",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         },
  //         "costs": {
  //           "individual": 25460.16,
  //           "individualAndSpouse": 9149.85,
  //           "individualAndChildren": 2943.86,
  //           "family": 12093.65,
  //           "totalMonthly": 49647.520000000004,
  //           "totalAnnual": 595770.24,
  //           "increase": -0.026343957598642054
  //         }
  //       },
  //       {
  //         "id": "4-2",
  //         "tier": 2,
  //         "planName": "GC OAPIN HSA (37042652)",
  //         "fundingType": "Fully Insured",
  //         "planType": "PPO",
  //         "hrahsa": "HSA",
  //         "notes": "Medical services where plan deductible applies are noted with a caret (^). Formulary: Advantage; Pharmacy Network: National",
  //         "rates": {
  //           "individual": 634.8,
  //           "individualAndSpouse": 1466.21,
  //           "individualAndChildren": 1178.42,
  //           "family": 1939.48
  //         },
  //         "enrollment": {
  //           "individual": 3,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1,
  //           "family": 3
  //         },
  //         "benefits": {
  //           "inNetwork": {
  //             "deductible": "$3,000 / $6,000 (Collective)",
  //             "officeVisitsPrimaryCare": "100% ^",
  //             "officeVisitsSpecialty": "$5 + 100% ^",
  //             "inpatientHospital": "100% ^",
  //             "emergencyRoom": "100% ^",
  //             "urgentCare": "100% ^",
  //             "lab": "Benefit Coins",
  //             "xray": null,
  //             "coinsurance": "100%",
  //             "outOfPocket": "$6,000 / $12,000 (Non-Collective)"
  //           },
  //           "outOfNetwork": {
  //             "deductible": "NA / NA",
  //             "coinsurance": "NA",
  //             "outOfPocket": "NA / NA"
  //           },
  //           "pharmacy": {
  //             "retailTier1": "$15",
  //             "retailTier2": "$35",
  //             "retailTier3": "$60",
  //             "retailTier4": "50%",
  //             "mailOrderTier1": "$30",
  //             "mailOrderTier2": "$70",
  //             "mailOrderTier3": "$120",
  //             "mailOrderTier4": "50%",
  //             "deductible": null,
  //             "outOfPocket": null
  //           }
  //         },
  //         "costs": {
  //           "individual": 1904.3999999999999,
  //           "individualAndSpouse": 0,
  //           "individualAndChildren": 1178.42,
  //           "family": 5818.4400000000005,
  //           "totalMonthly": 8901.26,
  //           "totalAnnual": 106815.12,
  //           "increase": 0.00048780926432945293
  //         }
  //       }
  //     ],
  //     "totalMonthly": 58548.780000000006,
  //     "totalAnnual": 702585.36,
  //     "increase": -0.02235783150274151
  //   }
  // ]);

  const [results, setResults] = useState();
  // const [results, setResults] = useState({
  //   "keyDifferences": [
  //     {
  //       "tier": 1,
  //       "comparable": true,
  //       "differences": {
  //         "inNetwork": [
  //           {
  //             "property": "officeVisitsPrimaryCare",
  //             "difference": "CareFirst and Cigna plans require $25 copay, while UHC charges $30 for PCP visits."
  //           },
  //           {
  //             "property": "officeVisitsSpecialty",
  //             "difference": "CareFirst and Cigna charge $50 copay, while UHC charges $60 for specialist visits."
  //           },
  //           {
  //             "property": "inpatientHospital",
  //             "difference": "CareFirst covers inpatient hospital at $0, while UHC and Cigna require deductible then 100%."
  //           },
  //           {
  //             "property": "emergencyRoom",
  //             "difference": "CareFirst and Cigna require $250 per ER visit, while UHC requires $400."
  //           },
  //           {
  //             "property": "urgentCare",
  //             "difference": "UHC requires $75 and Cigna $100 per urgent care visit; CareFirst does not specify an urgent care copay."
  //           },
  //           {
  //             "property": "lab",
  //             "difference": "UHC and Cigna cover lab services at $0 or benefit coins, while CareFirst lab cost is not specified."
  //           }
  //         ],
  //         "outOfNetwork": [
  //           {
  //             "property": "coinsurance",
  //             "difference": "CareFirst and Cigna require 20% coinsurance out-of-network, UHC requires 20% coinsurance on a higher max ($12,000/$24,000 vs $12,000/$24,000)."
  //           }
  //         ],
  //         "pharmacy": [
  //           {
  //             "property": "retailTier1",
  //             "difference": "UHC offers lowest generic drug cost ($10 vs $15 for CareFirst and Cigna)."
  //           },
  //           {
  //             "property": "retailTier3",
  //             "difference": "UHC has the highest cost for brand drugs ($80), while CareFirst and Cigna charge $60."
  //           },
  //           {
  //             "property": "retailTier4",
  //             "difference": "UHC specifies $150 for the highest cost drugs while CareFirst and Cigna use 50% coinsurance with maximums ($100-$150)."
  //           },
  //           {
  //             "property": "pharmacyDeductible",
  //             "difference": "CareFirst applies a $500 prescription deductible; Cigna and UHC have no dedicated pharmacy deductible."
  //           }
  //         ]
  //       }
  //     },
  //     {
  //       "tier": 2,
  //       "comparable": true,
  //       "differences": {
  //         "inNetwork": [
  //           {
  //             "property": "officeVisitsPrimaryCare",
  //             "difference": "CareFirst offers $0 PCP visit, Cigna applies deductible then 100%, UHC requires deductible plus $25."
  //           },
  //           {
  //             "property": "officeVisitsSpecialty",
  //             "difference": "CareFirst offers $5 copay for specialist, Cigna applies deductible then $5, UHC requires deductible plus $50."
  //           },
  //           {
  //             "property": "inpatientHospital",
  //             "difference": "CareFirst and Cigna provide inpatient coverage at $0 or after deductible, UHC requires deductible plus $500 for inpatient."
  //           },
  //           {
  //             "property": "emergencyRoom",
  //             "difference": "CareFirst and Cigna cover ER at $0 or after deductible, UHC requires deductible plus $300."
  //           },
  //           {
  //             "property": "urgentCare",
  //             "difference": "UHC requires deductible plus $75, Cigna is after deductible, CareFirst does not specify urgent care copay."
  //           },
  //           {
  //             "property": "outOfPocket",
  //             "difference": "UHC has a lower in-network out-of-pocket maximum ($5,000 vs $6,000 for CareFirst and Cigna)."
  //           }
  //         ],
  //         "outOfNetwork": [
  //           {
  //             "property": "coverage",
  //             "difference": "All options restrict or do not provide out-of-network coverage for tier 2."
  //           }
  //         ],
  //         "pharmacy": [
  //           {
  //             "property": "retailTier1",
  //             "difference": "UHC offers lower generic drug cost ($10 vs $15 for CareFirst and Cigna)."
  //           },
  //           {
  //             "property": "pharmacyDeductible",
  //             "difference": "CareFirst has integrated pharmacy deductible, UHC pharmacy applies to medical deductible, Cigna has no clear prescription deductible."
  //           }
  //         ]
  //       }
  //     }
  //   ],
  //   "recommendations": [
  //     {
  //       "goal": "Minimize Monthly Premium",
  //       "recommendedPlan": "UHC DSFI (Alternative Option 2)",
  //       "reason": "Lowest individual rate at $593.86/month and lowest corresponding family rates across options."
  //     },
  //     {
  //       "goal": "Minimize Out-of-Pocket Maximum",
  //       "recommendedPlan": "UHC DSFI (Alternative Option 2)",
  //       "reason": "Lowest in-network out-of-pocket maximum at $5,000 compared to $6,000 for CareFirst and Cigna."
  //     },
  //     {
  //       "goal": "Maximize Office Visit Benefits",
  //       "recommendedPlan": "CareFirst HMO Open Access Integrated CDH (Current/Renewal Option 2)",
  //       "reason": "$0 primary care and $5 specialist copays allow low-cost access to routine care."
  //     },
  //     {
  //       "goal": "Best Emergency Coverage",
  //       "recommendedPlan": "CareFirst HMO Open Access Integrated CDH (Current/Renewal Option 2)",
  //       "reason": "$0 emergency room copay reduces upfront cost in emergencies."
  //     },
  //     {
  //       "goal": "Optimize Pharmacy Coverage",
  //       "recommendedPlan": "UHC (All Options)",
  //       "reason": "Lowest generic drug cost at $10 per prescription. CareFirst and Cigna charge $15 for generics."
  //     },
  //     {
  //       "goal": "Best Family Value",
  //       "recommendedPlan": "UHC DSFI (Alternative Option 2)",
  //       "reason": "Lowest monthly cost for families ($1,805.33) with lower out-of-pocket maximums."
  //     },
  //     {
  //       "goal": "Best for Chronic Conditions",
  //       "recommendedPlan": "CareFirst HMO Open Access Integrated CDH (Current/Renewal Option 2)",
  //       "reason": "$0 primary care, low $5 specialist copays, and $0 emergency room benefit ongoing care needs."
  //     },
  //     {
  //       "goal": "Best for Healthy Individuals",
  //       "recommendedPlan": "UHC DSFI (Alternative Option 2)",
  //       "reason": "Lowest monthly premium and out-of-pocket maximum for those needing mainly catastrophic coverage."
  //     },
  //     {
  //       "goal": "Best for Frequent Travelers",
  //       "recommendedPlan": "UHC DR2Q (Alternative Option 1)",
  //       "reason": "PPO plan with broad national provider network and comprehensive out-of-network coverage."
  //     }
  //   ]
  // });

  const [processingTimes, setProcessingTimes] = useState();
  // const [processingTimes, setProcessingTimes] = useState({
  //   "upload_files": 0,
  //   "data_extraction": 0.04,
  //   "markdown_extraction": 36.8,
  //   "plans_extraction": 82.51
  // });

  useEffect(() => {
    // Fetch backend version on mount
    axios
      .get(`${API_URL}/version`)
      .then((res) => {
        setVersion(res.data.version);
      })
      .catch(() => setVersion(""));
  }, []);

  useEffect(() => {
    if (plansData.length > 0 && plansData.some(e => e.type === 'current') && plansData.some(e => e.type === 'renewal')) {
      for (const dataSet of plansData) {
        dataSet.plans.forEach((plan, planIndex) => {
          plan.tier = planIndex + 1;
        });
      }
      calculateCosts(plansData);
    }
    console.log(plansData);
  }, [plansData]);

  const handleUpload = async () => {
    if (!selectedFiles.find(e => e.current)) {
      setError(
        "Please select the file that contains the Current Plan information"
      );
      return;
    }
    if (!selectedFiles.find(e => e.renewal)) {
      setError(
        "Please select the file that contains the Renewal Plan information"
      );
      return;
    }
    for (const file of selectedFiles) {
      if (file.pages.trim() === "") {
        setError("Please enter page ranges/sheet names for all files.");
        return;
      }
    }

    try {
      setLoadingUpload(true);
      setError("");
      setLogs([]); // Clear previous logs

      const newProcessId = await axios.get(`${API_URL}/generate_id`);

      setProcessId(newProcessId.data.id);

      const sorted = [...selectedFiles].sort((a, b) => {
        if (a.current) return -1;
        if (b.current) return 1;
        if (a.renewal) return -1;
        if (b.renewal) return 1;
        return 0
      });

      const payload = new FormData();

      sorted.forEach((file) => {
        payload.append("files", file.file);
      });
      payload.append(
        "metadata",
        JSON.stringify(
          sorted.map((file) => ({
            id: file.id.toString(),
            name: file.name,
            format: file.format,
            current: file.current,
            renewal: file.renewal,
            pages: file.pages,
          }))
        )
      );
      payload.append("process_id", processId);
      const res = await axios.post(`${API_URL}/upload`, payload);

      setProcessingTimes(res.data.processing_times);
      setPlansData(res.data.plans_data);
      setOriginalPlansData(JSON.parse(JSON.stringify(res.data.plans_data)));
    } catch (err) {
      let message = "Failed to extract plans. Please try again.";
      if (err.response?.data?.detail) {
        message = err.response.data.detail;
      }
      setError(message);
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleReprocess = async (ids, fileId, fileName) => {
    try {
      setLoadingCompare(true);
      setReloadingIds([...reloadingIds, ...ids]);
      setError("");

      const sorted = [...selectedFiles].sort((a, b) => {
        if (a.current) return -1;
        if (b.current) return 1;
        if (a.renewal) return -1;
        if (b.renewal) return 1;
        return 0
      });

      const payload = new FormData();

      sorted.forEach((file) => {
        if (file.id.toString() === fileId && file.name === fileName) {
          payload.append("files", file.file);
        }
      });
      payload.append(
        "metadata",
        JSON.stringify(
          sorted.filter((file) => file.id.toString() === fileId && file.name === fileName).map((file) => ({
            id: file.id.toString(),
            name: file.name,
            format: file.format,
            current: file.current,
            renewal: file.renewal,
            pages: file.pages,
            reprocessingIds: ids
          }))
        )
      );
      payload.append("process_id", processId);
      const res = await axios.post(`${API_URL}/upload`, payload);

      setProcessingTimes(prev => ({
        upload_files: prev.upload_files + res.data.processing_times.upload_files,
        data_extraction: prev.data_extraction + res.data.processing_times.data_extraction,
        markdown_extraction: prev.markdown_extraction + res.data.processing_times.markdown_extraction,
        plans_extraction: prev.plans_extraction + res.data.processing_times.plans_extraction,
      }));
      
      setPlansData(prev => prev.map((oldPlan) => {
        if (ids.includes(oldPlan.id)) {
          return res.data.plans_data.find(newPlan => newPlan.id === oldPlan.id);
        }
        return oldPlan;
      }));
      setOriginalPlansData(JSON.parse(JSON.stringify(res.data.plans_data)));
    } catch (err) {
      let message = "Failed to extract plans. Please try again.";
      if (err.response?.data?.detail) {
        message = err.response.data.detail;
      }
      setError(message);
    } finally {
      setReloadingIds(prev => prev.filter(e => !ids.includes(e)));
      setLoadingCompare(false);
    }
  };

  const calculateCosts = (options) => {
    let current = null;
    options.forEach((option) => {
      let totalMonthly = 0;
      let totalAnnual = 0;
      option.plans.forEach((plan, index) => {
        const costs = {
          individual: (plan?.rates?.individual || 0) * (plan?.enrollment?.individual || 0),
          individualAndSpouse: (plan?.rates?.individualAndSpouse || 0) * (plan?.enrollment?.individualAndSpouse || 0),
          individualAndChildren: (plan?.rates?.individualAndChildren || 0) * (plan?.enrollment?.individualAndChildren || 0),
          family: (plan?.rates?.family || 0) * (plan?.enrollment?.family || 0)
        };
        costs.totalMonthly = costs.individual + costs.individualAndSpouse + costs.individualAndChildren + costs.family;
        costs.totalAnnual = costs.totalMonthly * 12;
        costs.increase = option.type === 'current' ? 0 : (current.plans[index]?.costs?.totalAnnual ? (costs.totalAnnual / (current.plans[index].costs.totalAnnual)) - 1 : 0);
        plan.costs = costs;
        totalMonthly += costs.totalMonthly;
        totalAnnual += costs.totalAnnual;
      });
      option.totalMonthly = totalMonthly;
      option.totalAnnual = totalAnnual;
      if (option.type === 'current') {
        current = option;
      } else {
        option.increase = (option.totalAnnual / (current.totalAnnual || 1)) - 1;
      }
    });
  }

  const handleCompare = async () => {
    try {
      setError("");
      setLoadingCompare(true);
      const comparablePlansData = plansData.filter(plan => plan.type !== "current");
      const res = await axios.post(`${API_URL}/compare`, { process_id: processId || "", plans_data: comparablePlansData });
      setResults(res.data.result);
      setProcessingTimes({ ...processingTimes, ...res.data.processing_times });
    } catch (err) {
      setError("Failed to compare plans. Please try again.");
    } finally {
      setLoadingCompare(false);
    }
  };

  const downloadFile = async (endpoint, fileType, defaultFilename) => {
    if (isDownloading) return;
    setError("");

    if (!benchmark) {
      setError(
        "Please select a year in the \"National Benchmark Average values\" section before generating a report."
      );
      return;
    }

    setIsDownloading(true);

    try {
      const payload = {
        process_id: processId,
        plans_data: plansData,
        consultant_compensation: consultantCompensation,
        benchmark_year: benchmark.year,
        results: results
      };

      const response = await axios.post(`${API_URL}/${endpoint}`, payload, {
        responseType: 'blob'
      });

      const contentDisposition = response.headers['Content-Disposition'];
      let filename = defaultFilename;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Error downloading ${fileType} file:`, error);
      setError(`Failed to download ${fileType} file. Please try again.`);
      setIsDownloading(false);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleRestoreOriginalPlansData = () => {
    setPlansData(JSON.parse(JSON.stringify(originalPlansData)));
  }

  const handleDownloadPDF = () => {
    downloadFile('download_pdf', 'PDF', 'Health Plan Comparison Report.pdf');
  };

  const handleDownloadXLSX = () => {
    downloadFile('download_xlsx', 'Excel', 'Health Plan Comparison Report.xlsx');
  };

  const handleClearAll = () => {
    setPlansData([]);
    setResults(null);
    setOriginalPlansData([]);
    setSelectedFiles([]);
    setError("");
    setConsultantCompensation({
      model: "per_employee",
      values: {}
    });
  };

  if (!authenticated) {
    return <Login onLogin={() => setAuthenticated(true)} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow p-6">
        <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">
          Carrier Benefits Analysis
        </h1>
        <UploadComponent
          loading={loadingUpload}
          selectedFiles={selectedFiles}
          editable={plansData.length === 0 && !loadingCompare}
          setSelectedFiles={setSelectedFiles}
          handleUpload={handleUpload}
          handleClearAll={handleClearAll}
          setError={setError}
        />
        {plansData.length > 0 && !results && (
          <>
            <EditEnrollment
              plansData={plansData}
              originalPlansData={originalPlansData}
              setPlansData={setPlansData}
            />
            <EditConsultantCompensation
              plansData={plansData}
              consultantCompensation={consultantCompensation}
              setConsultantCompensation={setConsultantCompensation}
            />
          </>
        )}
        {plansData.length > 0 && (
          <EditNationalBenchmark
            benchmark={benchmark}
            setBenchmark={setBenchmark}
          />
        )}
        {plansData.length > 0 && (
          <PlanOrganizer
            planData={plansData}
            keyDifferences={results?.keyDifferences}
            loading={loadingCompare || reloadingIds.length > 0}
            reloadingIds={reloadingIds}
            setPlansData={setPlansData}
            handleReprocess={handleReprocess}
            handleCompare={handleCompare}
            handleRestore={handleRestoreOriginalPlansData}
            consultantCompensation={consultantCompensation}
          />
        )}

        {results && (
          <PlanComparison recommendations={results?.recommendations} processingTimes={processingTimes} />
        )}

        {results && (
          <div className="flex justify-center space-x-4 mt-8">
            <button
              onClick={handleDownloadPDF}
              disabled={isDownloading || !results}
              className={`px-4 py-2 rounded ${isDownloading || !results
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-red-500 hover:bg-red-600'
                } text-white transition-colors`}
            >
              {isDownloading ? 'Downloading...' : 'Download PDF Report'}
            </button>
            <button
              onClick={handleDownloadXLSX}
              disabled={isDownloading || !results}
              className={`px-4 py-2 rounded ${isDownloading || !results
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-green-500 hover:bg-green-600'
                } text-white transition-colors`}
            >
              {isDownloading ? 'Downloading...' : 'Download Excel Report'}
            </button>
          </div>
        )}
        {error && <div className="text-red-600 my-2">{error}</div>}

        {(loadingUpload || loadingCompare) && processId && logs.length > 0 && (
          <div className="mb-4 p-2 bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800 text-sm font-mono">
            <strong>Processing:</strong> { }
          </div>
        )}

        {(loadingUpload || loadingCompare) && processId && (
          <div className="mb-4 p-2 bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800 text-sm font-mono">
            <strong>Processing:</strong> {"Please wait while we process your request... This may take a few minutes."}
          </div>
        )}

        <div className="mt-8 text-xs text-gray-400 text-center">
          Version: {version || "unknown"}
        </div>
      </div>
    </div>
  );
}

export default App;
